import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForLinkComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'headline', 'url', 'cmsState', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      isMainColumn: true,
      sortable: true,
    },
    {
      property: 'url',
      isTruncate: true,
      sortable: true,
      type: 'link',
    },
    {
      property: 'altText',
      sortable: true,
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
